module.exports = __webpack_public_path__ + "static/media/ains.50e8630a.png";